import { render, staticRenderFns } from "./SourceDetails.vue?vue&type=template&id=9e4a279a&scoped=true&"
import script from "./SourceDetails.vue?vue&type=script&lang=js&"
export * from "./SourceDetails.vue?vue&type=script&lang=js&"
import style0 from "./SourceDetails.vue?vue&type=style&index=0&id=9e4a279a&prod&lang=scss&"
import style1 from "./SourceDetails.vue?vue&type=style&index=1&id=9e4a279a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4a279a",
  null
  
)

export default component.exports